export default __webpack_public_path__ + "static/media/Brow_4_C3.4db3a37a.svg";